export default "__VITE_ASSET__2tpJbH5___"